import { render } from "./CloseWhite.svg?vue&type=template&id=724d181c"
const script = {}
script.render = render

export default script